import { createAllActions } from '@api/createRequestStore';
import * as types from './types';

export const init = () => ({
  type: types.INIT,
});

export const getSharing = id => ({
  type: types.GET_SHARING,
  id,
});

export const addNocSharingTab = () => ({
  type: types.ADD_NOC_SHARING_TAB,
});

const { init: initRequest, fetching } = createAllActions(types.SCOPE);

export { initRequest, fetching };
